import React from 'react';
import GoogleMap from '../google-map';
// import { browserName } from "react-device-detect";
import './selection-map-style.css';
import StringProcessingService from '../../services/string-processing-service'
import MarkerCustomInfoWindow from '../marker-custom-info-window/marker-custom-info-window';
const stringProcessingService = new StringProcessingService();

function SelectionMap(props) {
    let { dictionary, currentSelectionListing, selectionMapFloating, selectionMapSettings, width, height,
        listingExpiredList, hoveredMarkerId, listings, agentId,
        selectionId, mapSecondaryMarkers, mapSoldOutMarkers, currentPage, displayOnMobile = false, mapSide } = props;

    let coord;
    if (currentSelectionListing !== null && currentSelectionListing.Latitude !== undefined && currentSelectionListing.Longitude !== undefined) {
        coord = {
            lat: currentSelectionListing.Latitude,
            lng: currentSelectionListing.Longitude
        }
    }
    let mapTopPadding = 0;
    //,  paddingTop:window.scrollY-166
    let SelectionMapStyle = {

    }

    let routerMark = document.getElementsByClassName('RouterMark')[0];

    function handleOnMarkerHover(item) {
        return (
            <MarkerCustomInfoWindow
                dictionary={dictionary}
                item={item}
                type={'Projects'}
            />
        )
    }

    // selectionMapSettings:{
    //             elementHeaderId: "HeaderMain",
    //             elementHeaderIdOffset: '',
    //             elementFooterId: "Footer",
    //             elementFooterIdOffset: '',
    //             mapSide: 'right'
    //         }

    //if(document.location.pathname==='/projects'){
    if (selectionMapFloating) {
        let pos = 'relative';
        let yOffset = 0;
        let alignSelf = '';

        let footerHeight = document.getElementsByClassName('Footer')[0]?.scrollHeight

        var scrollHeight = Math.max(
            document.body.scrollHeight, document.documentElement.scrollHeight,
            document.body.offsetHeight, document.documentElement.offsetHeight,
            document.body.clientHeight, document.documentElement.clientHeight
        );

        let headerBlock = document.getElementsByClassName(selectionMapSettings.elementHeaderId)[0];
        let offsetBlock = document.getElementsByClassName(selectionMapSettings.elementHeaderIdOffset)[0];
        let offsetHeight = offsetBlock?.offsetHeight || 0;
        console.log('headerBlock', headerBlock);
        if (window.pageYOffset > headerBlock?.offsetHeight) {
            pos = 'fixed'
            yOffset = offsetHeight;
        }

        if (window.pageYOffset > scrollHeight - footerHeight - window.innerHeight) {
            pos = 'relative';
            alignSelf = 'flex-end'
            yOffset = 0
        }

        if (displayOnMobile && width < 1200) {
            pos = 'relative';
            yOffset = 0;
            alignSelf = 'unset'
        }


        


        // console.log('scrollHeight',scrollHeight);
        // console.log('window.pageYOffset',window.pageYOffset);

        // console.log('footerHeight',footerHeight);
        if(document && routerMark){
            SelectionMapStyle = { height: height - offsetHeight, width: (document.documentElement.clientWidth - routerMark.clientWidth), position: pos, top: yOffset, alignSelf: alignSelf };

            if(mapSide){
                SelectionMapStyle ={
                    ...SelectionMapStyle,
                    right: mapSide === 'right' ? 0 : 'unset',
                    left: mapSide === 'left' ? 0 : 'unset',
                }
            }
        }
        console.log('SelectionMapStyle', SelectionMapStyle);
    }
    console.log('SelectionMapStyle before render', props);
   if ((displayOnMobile || width > 1000) && listings !== undefined) {
        return (
            <div className='SelectionMap' style={SelectionMapStyle}>
                <GoogleMap
                    // width={`${window.screen.width/2.5}px`}
                    // height={`${window.screen.height/1.4}px`}
                    mapSoldOutMarkers={mapSoldOutMarkers}
                    mapSecondaryMarkers={mapSecondaryMarkers}
                    width='100%'
                    height='100%'
                    minHeight={displayOnMobile ? '400px' : '0'}
                    coord={coord}
                    screenWidth={width}
                    hoveredMarkerId={hoveredMarkerId}
                    handleOnMarkerHover={handleOnMarkerHover}
                    dataCenter={currentSelectionListing === null ? true : false}
                    dataMarkers={true}
                    listingExpiredList={listingExpiredList}
                    data={listings}
                    agentId={agentId}
                    selectionId={selectionId}
                    currentSelectionListing={currentSelectionListing}
                    currentPage={currentPage}
                />

            </div>
        )
    } else return null;
}
export default SelectionMap;